import { render, staticRenderFns } from "./DealServingsSavingCost.vue?vue&type=template&id=338d9e6e&scoped=true"
import script from "./DealServingsSavingCost.vue?vue&type=script&lang=js"
export * from "./DealServingsSavingCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d9e6e",
  null
  
)

export default component.exports